
import './App.css';
import { HashRouter as Router ,Routes,Route } from 'react-router-dom';
import Singup from './Component/Singup';
import Container from './Component/Container';
import Log from './Component/Log';
import Poductid from './Component/Poductid';
import Contenth from './Component/Contenth';
import { products } from './Component/Product';
import {  useEffect, useState } from 'react';
function App() {
  const [productd,setproductd] = useState("");
  const [content,setcontent] = useState(products);
  return (
    <>
    <Router>
      <Routes>
        <Route path='/' element={<Container  setcontent={setcontent}/>}>
        <Route path='/' element={<Contenth content = {content} setproductd={setproductd}/>}/>
        <Route path='/product' element={<Poductid productd={productd}/>}/>
        </Route>
        <Route path ='/Login' element={<Log/>}/>
        <Route path='/Singup' element={<Singup/>}/>
      </Routes>
    </Router>
    </>
  );
}

export default App;
